export default __webpack_public_path__ + "static/media/los-angeles.c660f49e.png";